import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

export const DefectsHeaderColumnGroupTemplates: any = {
    'DefectsGOST': DefectsGOSTHeaderColumnGroupTemplate,
    'DefectsODM': DefectODMHeaderColumnGroupTemplate
}

function DefectsGOSTHeaderColumnGroupTemplate() {
    return (
        <ColumnGroup>
            <Row>
                <Column header="Начало" colSpan={2} align="center" />
                <Column header="Конец" colSpan={2} align="center" />
                <Column header="Дефекты слева" rowSpan={2} colSpan={1} align="center" />
                <Column header="Дефекты справа" rowSpan={2} colSpan={1} align="center" />
            </Row>
            <Row>
                <Column header="Км" colSpan={1} rowSpan={1} align="center" field="Position" />
                <Column header="Км+" colSpan={1} rowSpan={1} align="center" field="MaintenancePosition" />
                <Column header="Км" colSpan={1} rowSpan={1} align="center" field="Ending" />
                <Column header="Км+" colSpan={1} rowSpan={1} align="center" field="MaintenanceEnding" />
            </Row>
        </ColumnGroup>
    )
}

function DefectODMHeaderColumnGroupTemplate() {
    return (
        <ColumnGroup>
            <Row>
                <Column header="Начало" colSpan={2} align="center" />
                <Column header="Конец" colSpan={2} align="center" />
                <Column header="Оценка в баллах" rowSpan={2} colSpan={1} align="center" />
            </Row>
            <Row>
                <Column header="Км" colSpan={1} rowSpan={1} align="center" field="Position" />
                <Column header="Км+" colSpan={1} rowSpan={1} align="center" field="MaintenancePosition" />
                <Column header="Км" colSpan={1} rowSpan={1} align="center" field="Ending" />
                <Column header="Км+" colSpan={1} rowSpan={1} align="center" field="MaintenanceEnding" />
            </Row>
        </ColumnGroup>
    )
}